import React from 'react';
import Form, { Actions, Radio, Checkboxes, TextField } from '../../../Components/Form';
import { useModal } from '../../../Components/Modal';

const PaymentsSearch = ({searchData, setSearchData}) => {
    const {closeModal} = useModal();

    const clearSearch = () => {
        setSearchData({});
        closeModal();
    }

    return <Form data={searchData} onSubmit={setSearchData} closeModalOnSubmit>
        <TextField name="search" label="Search" />

        <Radio name="hasCustomer"
            label="Linked to customer"
            layout="SmallCards"
            options={[
                { value: 'Either', label: 'Either' },
                { value: 'true', label: 'Yes' },
                { value: 'false', label: 'No' },
            ]}
        />

        <Checkboxes name="statuses"
            label="Status"
            options={[
                {value: 'Completed', label: 'Completed'},
                {value: 'Confirmed', label: 'Confirmed'},
                {value: 'Cleared', label: 'Cleared'},
                {value: 'Refunded', label: 'Refunded'},
                {value: 'Disputed', label: 'Disputed'},
                {value: 'Deleted', label: 'Deleted'},
                {value: 'Failed', label: 'Failed'},
            ]}
        />

        <Checkboxes name="paymentMethods"
            label="Payment method"
            options={[
                {value: 'BACS', label: 'Direct Debit (BACS)'},
                {value: 'CARD', label: 'Card'},
                {value: 'CARD RECURRING', label: 'Card Recurring'},
                {value: 'MOBILE', label: 'Mobile'},
                {value: 'TRANSFER', label: 'Bank Transfer'},
                {value: 'CASH', label: 'Cash'},
                {value: 'EXTERNAL CASH', label: 'External Cash'},
                {value: 'EXTERNAL CHEQUE', label: 'External Cheque'},
                {value: 'EXTERNAL TRANSFER', label: 'External Transfer'},
                {value: 'EXTERNAL CARD', label: 'External Card'},
                {value: 'EXTERNAL OTHER', label: 'External Other'},
            ]}
        />
        <Actions submit={{label: 'Search'}} cancel={{label: 'Clear', onClick: clearSearch}} />
    </Form>;
}

export default PaymentsSearch;
